import { useEffect } from "react";
import { atom } from "nanostores";

export const $sidebarCollapsed = atom<boolean>(false);
export const $collapseButtonVisible = atom<boolean>(true);

export const sidebarActions = {
  toggle: () => $sidebarCollapsed.set(!$sidebarCollapsed.get()),
  collapse: () => $sidebarCollapsed.set(true),
  expand: () => $sidebarCollapsed.set(false),
  set: (value: boolean) => $sidebarCollapsed.set(value),
  hideCollapseButton: () => $collapseButtonVisible.set(false),
  showCollapseButton: () => $collapseButtonVisible.set(true),
  toggleCollapseButtonVisibility: () =>
    $collapseButtonVisible.set(!$collapseButtonVisible.get()),
};

export const useHandleNestedNav = () => {
  useEffect(() => {
    sidebarActions.collapse();
    sidebarActions.hideCollapseButton();

    return () => {
      sidebarActions.expand();
      sidebarActions.showCollapseButton();
    };
  }, []);
};
